import { render, staticRenderFns } from "./BoxColor.vue?vue&type=template&id=659f8d17&"
import script from "./BoxColor.vue?vue&type=script&lang=js&"
export * from "./BoxColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports